import { render, staticRenderFns } from "./PopupRelease.vue?vue&type=template&id=36288eb6&"
import script from "./PopupRelease.vue?vue&type=script&lang=js&"
export * from "./PopupRelease.vue?vue&type=script&lang=js&"
import style0 from "./PopupRelease.vue?vue&type=style&index=0&id=36288eb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports